import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components/macro';
import { screenType } from 'types';

export const screens = {
  mobile: {
    width: '414px',
    height: 'auto',
  },
  tablet: {
    width: '768px',
    height: 'auto',
  },
  desktop: {
    width: '100%',
    height: 'auto',
  },
};

export const screensOpts = [
  {
    label: 'telémovel',
    value: 'mobile',
    icon: 'fal fa-mobile',
  },
  {
    label: 'computador',
    value: 'desktop',
    icon: 'fal fa-desktop',
  },
];

export const ResponsiveViewer = ({ screen, children }) => {
  const computedScreen = useMemo(() => screens[screen], [screen]);

  return (
    <Viewer
      width={computedScreen.width}
      height={computedScreen.height}
      screen={screen}
    >
      {children}
    </Viewer>
  );
};

const Viewer = styled.div(
  props => css`
    width: ${props.width || '100%'};
    height: ${props.height || '100%'};
    ${props.screen === 'mobile' || props.screen === 'tablet'
    ? css`
          margin-left: auto;
          margin-right: auto;
          margin-top: ${props.theme.spacing.l};
          border: 1px solid ${props.theme.colors.borderLighter};
        `
    : ''};
  `
);

ResponsiveViewer.propTypes = {
  screen: screenType,
  children: PropTypes.node,
};

ResponsiveViewer.defaultProps = {
  screen: 'desktop',
  children: null,
};

export default ResponsiveViewer;
